import PagesHeader from "./PagesHeader";
import { useTranslation } from "react-i18next";
import FilterSearch from "./FilterSearch";
import Table from "./Table";
import { useMyContext } from "../context";
import useRoles from "../hooks/useRoles";
import useFilter from "../hooks/useFilter";
import Pagination from "./Pagination";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
const RolesTable = () => {
  const { t } = useTranslation();

  const { handleOpenModal, openModal } = useMyContext();
  const { data, error, isError, isLoading } = useRoles();
  const navigate = useNavigate();
  useEffect(() => {
    if (error?.status === 401) {
      sessionStorage.removeItem("ecoRefreshToken");
      sessionStorage.removeItem("ecoToken");
      navigate("/");
    }
  }, []);
  const { setFilter, setTablePage } = useFilter();
  return (
    <div className="bg-third rounded-3xl p-6 flex flex-col gap-5">
      <div className="flex md:flex-row flex-col items-center justify-between gap-5">
        <PagesHeader title={t("admin.rolesManagement")} />
        <button
          onClick={() => handleOpenModal("addEditRole")}
          className="md:w-[200px] w-full h-[50px] rounded-xl bg-secondary flex items-center justify-center gap-3 text-white cursor-pointer"
        >
          <img src="/img/role.svg" alt="" />
          Add New Role
        </button>
      </div>
      <FilterSearch />
      <Table
        tableHeader={[
          "Role ID",
          "Role Name",
          "Description",
          "Number of Employees",
          "Created Date",
          "Last Updated",
          "Actions",
        ]}
        tableData={data?.data?.list}
        error={error}
        isError={isError}
        loading={isLoading}
        type="roles"
        openModal={openModal}
      />
      <Pagination
        paginate={{
          pageNumber: data?.data?.current_page,
          totalPages: data?.data?.total_pages,
          hasNext: data?.data?.has_next,
        }}
        setFilter={setFilter}
        setTablePage={setTablePage}
      />
    </div>
  );
};

export default RolesTable;
